import { render, staticRenderFns } from "./AppChip.vue?vue&type=template&id=4dceb16a&scoped=true"
import script from "./AppChip.vue?vue&type=script&lang=js"
export * from "./AppChip.vue?vue&type=script&lang=js"
import style0 from "./AppChip.vue?vue&type=style&index=0&id=4dceb16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dceb16a",
  null
  
)

export default component.exports